import gql from 'graphql-tag';
import { parseToMutationRequestUser } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequestUser(data, [
    'objectType',
    'reasonCode',
    'index',
    'approvalRequired',
    'approvalCorrespondence',
    'rejectionCorrespondence',
  ]);
  const modifyConfigApprovalLevel = `modifyConfigApprovalLevel(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyConfigApprovalLevel} {
      id
    }
  }
`;
};
